module.exports = __webpack_public_path__ + "img/578c313c9e6e66aa8e33f9fd83a0b4a3.png";